export const APPLY_STATUS = {
  ACTIVE: 'active',
  CANCELLED: 'cancelled',
  REJECTED: 'rejected',
  SUBMITTED: 'submitted',
};

export const MILESTONES = [
  { bonus: 0, referrals: 1 },
  { bonus: 50, referrals: 5 },
  { bonus: 100, referrals: 10 },
  { bonus: 200, referrals: 20 },
  { bonus: 300, referrals: 30 },
  { bonus: 400, referrals: 40 },
  { bonus: 500, referrals: 50 },
];

export const PAYOUT_STATUS = {
  AWAITING_UPGRADE: 'awaiting_upgrade',
  PAID: 'paid',
  PENDING_PAYOUT: 'pending_payout',
};
